import { GetRequest, PostRequest, PutRequest } from "@/api/service"

const ControllerName = "AccountManagerOrder"

export const GetAllAMOrders = (link) =>
    GetRequest(ControllerName + link)

export const GetAMSubmittedOrders = (link) =>
    GetRequest(`${ControllerName}/submitted-requests${link || ""}`)

export const AMAskForQuotation = (requests) =>
    PostRequest(`${ControllerName}/ask-for-quotation`, requests)

export const    GetAMDetails = (brokerPatientId) =>
    GetRequest(`${ControllerName}/get-details/${brokerPatientId}`)

export const GetAMOrderQuotationDetials = (medicalOrderId) =>
    GetRequest(`${ControllerName}/get-quotation-details/${medicalOrderId}`)


export const GetAMOrderProviderQuotationResponseDetails = (hospitalRequestId) =>
    GetRequest(`${ControllerName}/get-provider-quotation-response-details/${hospitalRequestId}`)


export const AMAcceptQuotation = (OrderId) =>
    PutRequest(`${ControllerName}/finalize-request-quotation/${OrderId}`)

export const AMGetLookups = () =>
    GetRequest(`${ControllerName}/account-manager-provider-lookup`)


export const AddMissingDataMessage = (PatientId,message)=>
    PutRequest(`${ControllerName}/ask-for-missing-data/${PatientId}`,{message})


